<template>
    <div class="newsletter" id="newsletter-form-page">
        <bread-crumb :breadcrumb="[
        {title:'Home', url:'/',status: false},
        {title:'Newsletter' , url:'/newsletter',status: true}]">
        </bread-crumb>
        <section id="thankyou_text" class="section with_pad" v-if="subscribeMessage">
            <div class="wrapper">
                <div class="main_title">
                    <h3>Terima Kasih</h3>
                    <p class="font-s-18">{{ subscribeMessage }}</p>
                </div>
                <div class="row_form">
                    <div class="row_button">
                        <a href="/" class="red_bt inliner">Kembali</a>
                    </div>
                </div>
            </div>
        </section>
        <section class="section with_pad" v-else>
            <div class="overlay">
                <div class="container card" :style="{ height: step == 4 ? '100%' : 'auto', overflow: step == 4 ? 'auto' : 'initial' }">
                    <div class="button-close">
                        <a href="/"><i class="ion-android-close"></i></a>
                    </div>
                    <div class="line_title">
                        <h3>
                            <span class="title-wrapper">
                                <span class="icon" :style="{
                                    backgroundImage: `url(${cdn_url}/uploads/page/banner/vector-11072022-102403.png)`,
                                }" style="background-size: auto 30px; background-position: center">
                                </span>
                                Newsletter
                            </span>
                        </h3>
                    </div>
                    <div class="summary" v-if="step == 1">
                        <p>Yuk jadi orang pertama yang mengetahui info produk dan promo terbaru sepeda motor Honda.</p>
                    </div>
                    <form method="POST" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)"
                        enctype="multipart/form-data">
                        <div class="row_form">
                            <fieldset class="section-1" v-if="step == 1">
                                <div class="main_title">
                                    <h3>Pilih Topik Yang Diinginkan</h3>
                                </div>
                                <p class="subtitle-section">Topik Berita</p>
                                <div v-for="(audience, index) in audiences" :key="index" class="form-radio-custom"
                                    :class="{ selected: currentTopic.id == audience.id, error: form.errors.has('topic')}">
                                    <label :for="audience.id">{{ audience.name }}</label>
                                    <input type="radio" :id="audience.id" :value="audience" v-model="currentTopic">
                                </div>
                                <span class="help-block" v-if="form.errors.has('topic')"
                                    v-text="form.errors.get('topic')"></span>
                            </fieldset>
                            <fieldset class="section-2" v-if="step == 2 && form.topic == 'Promo'">
                                <div class="main_title">
                                    <h3>Pilih Topik Promo</h3>
                                </div>
                                <p class="subtitle-section">Topik Berita</p>
                                <div v-for="(topic_promo, index) in topicPromos" :key="index" class="form-radio-custom"
                                    :class="{ selected: currentTopicPromo.name == topic_promo.name, error: form.errors.has('topic_promo')}">
                                    <label :for="topic_promo.id">{{ topic_promo.name }}</label>
                                    <input type="radio" :id="topic_promo.id" :value="topic_promo"
                                        v-model="currentTopicPromo">
                                </div>
                                <span class="help-block" v-if="form.errors.has('topic_promo')"
                                    v-text="'Topik Promo'+ form.errors.get('topic_promo')"></span>
                            </fieldset>
                            <fieldset class="section-3" v-if="step == 3 && form.topic_promo == 'Unit'">
                                <div class="main_title">
                                    <h3>Unit</h3>
                                </div>
                                <p class="subtitle-section">Pilih Kategori dan varian motor</p>
                                <div class="form-group">
                                    <div class="custom-select-newsletter">
                                        <div class="select-field"
                                            :class="{ isActive: dropdownCategory, error: form.errors.has('category_motor')}">
                                            <div v-if="categories.length > 0" class="wrap-selected">
                                                <div class="selected-item" v-for="(category, index) in categories"
                                                    :key="index">
                                                    <span>{{ category.title }}</span>
                                                    <a class="deleted-btn" @click="deleteOption('category', category)">
                                                        <span><i class="ion-android-close"></i></span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-else>Pilih Kategori</div>
                                            <a class="dropdown-arrow" @click="openDropdown('category')">
                                                <span :class="{ isActive: dropdownCategory }">
                                                    <i class="ion-chevron-down"></i>
                                                </span>
                                            </a>
                                        </div>
                                        <Transition name="fade">
                                            <div class="dropdown-option" :class="{ isActive: dropdownCategory }"
                                                v-show="dropdownCategory">
                                                <div class="option-item">
                                                    <a v-for="(category, index) in categoryMotors" :key="index"
                                                        class="item" :id="category.id"
                                                        @click="selectCategory(category)">
                                                        {{ category.title }}
                                                    </a>
                                                </div>
                                                <div class="footer-nore">
                                                    <p>*Kategori dapat dipilih lebih dari satu</p>
                                                    <div class="footer-action">
                                                        <a class="red_line_bt black_tx"
                                                            @click="openDropdown('category')">Selanjutnya</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </Transition>
                                    </div>
                                    <span class="help-block" v-if="form.errors.has('category_motor')"
                                        v-text="'Kategori motor ' + form.errors.get('category_motor')"></span>
                                    <!-- End Custom Select -->
                                </div>
                                <div class="form-group">
                                    <div class="custom-select-newsletter">
                                        <div class="select-field"
                                            :class="{ isActive: dropdownVariant, error: form.errors.has('variant_motor') }">
                                            <div v-if="variants.length > 0" class="wrap-selected">
                                                <div class="selected-item" v-for="(variant, index) in variants"
                                                    :key="index">
                                                    <span>{{ variant.title }}</span>
                                                    <a class="deleted-btn" @click="deleteOption('variant', variant)">
                                                        <span><i class="ion-android-close"></i></span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-else>Pilih Varian</div>
                                            <a class="dropdown-arrow" @click="openDropdown('variant')">
                                                <span :class="{ isActive: dropdownVariant }">
                                                    <i class="ion-chevron-down"></i>
                                                </span>
                                            </a>
                                        </div>
                                        <Transition name="fade">
                                            <div class="dropdown-option" :class="{ isActive: dropdownVariant }"
                                                v-show="dropdownVariant">
                                                <div class="option-group" v-for="(variant, index) in variantMotors"
                                                    :key="index">
                                                    <span class="title-group">{{ variant.group }}</span>
                                                    <div class="option-item">
                                                        <a v-for="(product, indexProd) in variant.products"
                                                            :key="indexProd" class="item" :id="product.id"
                                                            @click="selectVariant(product)">
                                                            {{ product.title }}
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="footer-nore">
                                                    <p>*Varian dapat dipilih lebih dari satu</p>
                                                    <div class="footer-action">
                                                        <a class="red_line_bt black_tx"
                                                            @click="openDropdown('variant')">Selanjutnya</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </Transition>
                                    </div>
                                    <span class="help-block" v-if="form.errors.has('variant_motor')"
                                        v-text="'Varian motor ' + form.errors.get('variant_motor')"></span>
                                    <!-- End Custom Select -->
                                </div>
                            </fieldset>
                            <fieldset v-if="step == 4">
                                <div class="main_title">
                                    <h3>Informasi Data Diri</h3>
                                </div>
                                <div class="form-group">
                                    <label for="name">Nama</label>
                                    <input type="text" name="name" class="form-control"
                                        :class="{ error: form.errors.has('name') }" placeholder="Tulis Nama Anda"
                                        v-model="form.name">
                                    <span class="help-block" v-if="form.errors.has('name')"
                                        v-text="form.errors.get('name')"></span>
                                </div>
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input type="email" name="email" class="form-control"
                                        :class="{ error: form.errors.has('email') }" placeholder="Tulis Email Anda"
                                        v-model="form.email">
                                    <span class="help-block" v-if="form.errors.has('email')"
                                        v-text="form.errors.get('email')"></span>
                                    <span class="help-block" v-if="errors.email" v-text="errors.email"></span>
                                </div>
                                <div class="form-group">
                                    <label for="phone">No Telepon</label>
                                    <input type="number" name="phone" class="form-control"
                                        :class="{ error: form.errors.has('phone') }" placeholder="Tulis Nomor Telepon"
                                        v-model="form.phone">
                                    <span class="help-block" v-if="form.errors.has('phone')"
                                        v-text="form.errors.get('phone')"></span>
                                </div>
                                <div class="form-group">
                                    <label for="province">Propinsi</label>
                                    <v-select label="name" :options="provinces" :reduce="province => province.id"
                                        v-model="form.province_id" placeholder="Pilih Propinsi"></v-select>
                                    <span class="help-block" v-if="form.errors.has('province_id')"
                                        v-text="'Province ' + form.errors.get('province_id')"></span>
                                </div>
                                <div class="form-group flex-agreement">
                                    <div class="agreement">
                                        <input type="checkbox" @change="changeAgree($event)" v-model="agree" name="agree" />
                                    </div>
                                    <div class="text-checkbox">
                                        <span v-html="pagePrivacy.summary"></span>
                                        <span class="help-block" v-if="form.errors.has('agree')" v-text="form.errors.get('agree')"></span>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div class="row_form">
                            <span class="help-block" v-if="form.errors.has('captcha_token')" v-text="form.errors.get('captcha_token')"></span>
                        </div>

                        <div class="row_form">
                            <div v-if="loader" class="loading loading-double"></div>
                            <div v-else class="row_button">
                                <a v-if="step > 1" class="red_line_bt" @click="back">Kembali</a>
                                <button type="submit" class="red_bt">Selanjutnya</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
import Form from "../../../lib/Form";
import BreadCrumb from "../../widget/BreadCrumb.vue";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { sha256, sha224 } from 'js-sha256';

export default {
    components: {
        'bread-crumb': BreadCrumb,
        'v-select': vSelect,
    },
    data() {
        return {
            base_url: base_url,
            errors: [],
            loader: false,
            cdn_url: cdn_url,
            step: 1,
            dropdownVariant: false,
            dropdownCategory: false,
            categoryMotors: [],
            variantMotors: [],
            provinces: [],
            selectedCategories: [],
            selectedProducts: [],
            audiences: [],
            selectElem: null,
            currentTopic: "",
            currentTopicPromo: "",
            topicSlug : "",
            subTopicSlug : "",
            subscribeMessage: false,
            topicPromos: [
                { id: 1, name: 'Promo Unit', slug: 'Unit' , type: 'promo-unit'},
                { id: 2, name: 'Promo Bengkel', slug: 'Bengkel', type: 'promo-bengkel' },
                { id: 3, name: 'Promo Parts', slug: 'Parts', type: 'promo-parts'},
                { id: 4, name: 'Promo Aksesoris & Apparel', slug: 'Aksesoris & Apparel', type: 'promo-aksesoris-apparel' },
            ],
            form: new Form({
                step: 1,
                complete: false,
                topic: "",
                name: "",
                email: "",
                phone: "",
                province_id: "",
                audience_id: "",
                topic_promo: "",
                category_motor: "",
                variant_motor: "",
                captcha_token: "",
                agree: ""
            }),
            agree: false,
            pagePrivacy: {},
        }
    },
    computed: {
        variants() {
            return this.selectedProducts;
        },
        categories() {
            let data = this.selectedCategories.map((item) => {
                return item.id
            });
            this.fetchProducts(data);
            return this.selectedCategories;
        }
    },
    watch: {
        currentTopic(data) {
            this.form.topic = data.name !== undefined ? data.name : "";
            this.form.audience_id = data.audience_id !== undefined ? data.audience_id : "";
            this.topicSlug = data.slug !== undefined ? data.slug : "";
        },
        currentTopicPromo(data) {
            this.form.topic_promo = data.slug !== undefined ? data.slug : "";
            this.subTopicSlug = data.type !== undefined ? data.type : "";
        },
        selectedCategories(data) {
            this.form.category_motor = data.length ? JSON.stringify(data) : "";
        },
        selectedProducts(data) {
            this.form.variant_motor = data.length ? JSON.stringify(data) : "";
        }

    },
    created() {
        this.fetchPagePrivacy();
        this.fetchCategory();
        this.fetchProvince();
        this.fetchAudience();
    },
    methods: {
        back() {
            this.form.complete = false;
            this.errors = [];
            if (this.currentTopic.name == "Promo") {
                if (this.form.topic_promo != "Unit" && this.form.topic_promo != null) {
                    this.step = parseInt(this.form.step) - 2;
                    this.form.step = this.step;
                    if (this.step <= 0) {
                        this.step = 1;
                        this.form.step = this.step;
                    }
                } else {
                    this.step = parseInt(this.form.step) - 1;
                    this.form.step = this.step;

                    this.selectedCategories = [];
                    this.selectedProducts = [];
                }
            } else {
                this.step = parseInt(this.form.step) - 3;
                this.form.step = this.step;
            }
            if (this.step == 1 || this.step == "1") {
                this.currentTopic = "";
                this.currentTopicPromo = "";
                this.form = new Form({
                    step: 1,
                    complete: false,
                    topic: "",
                    name: "",
                    email: "",
                    phone: "",
                    province_id: "",
                    audience_id: "",
                    topic_promo: "",
                    category_motor: "",
                    variant_motor: "",
                    captcha_token: "",
                    agree: ""
                });
                this.agree = false;
                this.errors = [];
            }
        },
        onSubmit() {
            this.loader = true;
            let that = this;
            if (this.step == 4) {
                this.form.complete = true;
            }
            grecaptcha.ready(function() {
                grecaptcha.execute(process.env.MIX_GOOGLE_RECAPTCHA_SITE_KEY, {action: 'newsletter_community'}).then(function(token) {
                    that.form.captcha_token = token;

                    that.form.post(api_mainsite_url + '/newsletter').then(response => {
                        if (response.success == true) {
                            localStorage.setItem('newsletter', JSON.stringify(response))
                            that.trackerLayer(4, response.data);
                            window.location.href = `${that.base_url}/newsletter/thank-you/${that.topicSlug}/${that.subTopicSlug}`;
                            that.loader = false;
                        } else if (response.success == false && response.exist == true) {
                            that.form = new Form(response.request);
                            that.errors = response.errors;
                            that.step = parseInt(that.form.step);
                            that.form.step = that.step;
                            that.loader = false;
                        } else {
                            that.form = new Form(response.request);
                            that.trackerLayer(that.form.step, that.form);
                            if (that.currentTopic.name == 'Promo') {
                                if (that.form.topic_promo != "Unit" && that.form.topic_promo != null) {
                                    that.step = parseInt(that.form.step) + 2;
                                    that.form.step = that.step;
                                } else {
                                    that.step = parseInt(that.form.step) + 1;
                                    that.form.step = that.step;
                                }
                            } else {
                                that.step = parseInt(that.form.step) + 3;
                                that.form.step = that.step;
                            }
        
                            that.loader = false;
                        }
                    }).catch((error) => {
                        console.log(error);
                        that.loader = false;
                    });
                })
            })
        },
        trackerLayer(step, data) {
            if (parseInt(step) == 1 || parseInt(step) == "1" || parseInt(step) == 2 || parseInt(step) == "2") {
                var event = {
                    'event': 'newSubscription',
                    'eventDetail.category': 'New Newsletter Subscription',
                    'eventDetail.action': parseInt(step) == 1 || parseInt(step) == "1" ? 'Choose Topic Menu Click' : 'Choose Topic Promo Menu Click',
                    'eventDetail.label': parseInt(step) == 1 || parseInt(step) == "1" ? 'Click ' + data.topic : 'Click ' + 'Promo ' + data.topic_promo,
                    'pageURL': window.location.href
                }
                dataLayer.push(event);
            }
            if (parseInt(step) == 3 || parseInt(step) == "3") {
                var event = {
                    'event': 'newSubscription',
                    'eventDetail.category': 'New Newsletter Subscription',
                    'eventDetail.action': 'Select Unit Product - Promo Menu Click (Choose Min. 1)',
                    'eventDetail.label': this.dataMapTitleJoin(data.category_motor),
                    'motorVariant': this.dataMapTitleJoin(data.variant_motor),
                    'pageURL': window.location.href
                }
                dataLayer.push(event);
            }
            if (parseInt(step) == 4 || parseInt(step) == "4") {
                var event = {
                    'event': 'newSubscription',
                    'eventDetail.category': 'New Newsletter Subscription',
                    'eventDetail.action': 'Fill Personal Information',
                    'eventDetail.label': 'Click Button Selanjutnya',
                    'name': sha256(data.name),
                    'email': sha256(data.email),
                    'phone': sha256(data.phone),
                    'province': data.province,
                    'pageURL': window.location.href
                }
                dataLayer.push(event);
            }
        },
        dataMapTitleJoin(event) {
            let dataParse = JSON.parse(event);
            let data = dataParse.map((item) => {
                return item.title
            });
            return data.join(', ');
        },
        async fetchPagePrivacy() {
            try {
                const response = await axios.get(
                    `${api_mainsite_url}/page/type/persetujuan-privasi`
                );

                this.pagePrivacy = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async fetchAudience() {
            try {
                const response = await axios.get(api_mainsite_url + '/audience');
                if (response.status == 200) {
                    this.audiences = response.data;
                    console.log(this.audiences);
                }
            } catch (error) {
                console.log(error);
            }
        },
        async fetchCategory() {
            try {
                const response = await axios.get(api_mainsite_url +'/product/category');
                this.categoryMotors = response.data.map((item) => {
                    return {
                        id: item.id,
                        title: item.title,
                        slug: item.slug
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        async fetchProducts(data) {
            try {
                const response = await axios.get(api_mainsite_url + '/product/groupWhereIn?whereIn=' + data);
                this.variantMotors = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async fetchProvince() {
            try {
                const response = await axios.get(api_mainsite_url + '/province');
                if (response.status == 200) {
                    this.provinces = response.data;
                }
            } catch (error) {
                console.log(error);
            }
        },
        openDropdown(event) {
            if (event == 'category') {
                this.dropdownCategory = !this.dropdownCategory;
                this.dropdownVariant = false;
            } else {
                this.dropdownVariant = !this.dropdownVariant;
                this.dropdownCategory = false;
            }
        },
        deleteOption(data, value) {
            if (data == 'category') {
                this.selectedCategories = this.selectedCategories.filter(val => {
                    return val.id != value.id;
                });
            } else {
                this.selectedProducts = this.selectedProducts.filter(val => {
                    return val.id != value.id;
                });
            }
            document.getElementById(value.id).classList.remove('selected');
        },
        selectVariant(data) {
            let find = this.selectedProducts.filter(val => {
                return val.id == data.id;
            });
            if (find.length == 0) {
                this.selectedProducts.push(data);
                document.getElementById(data.id).classList.add('selected');
            }
        },
        selectCategory(data) {
            let find = this.selectedCategories.filter(val => {
                return val.id == data.id;
            });
            if (find.length == 0) {
                this.selectedCategories.push(data);
                document.getElementById(data.id).classList.add('selected');
            }
        },
        changeAgree(event) {
            if (event.target.checked) {
                this.form.agree = true;
                this.agree = true;
            } else {
                this.form.agree = '';
                this.agree = false;
            }
        },
    }
}
</script>
<style lang="scss">
#newsletter-form-page {
    margin-bottom: 8em;
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
    .vs__dropdown-toggle {
        padding: 10px 20px;
        border-radius: 10px;
    }
    .vs__search {
        margin: 0;
    }
    .vs__open-indicator {
        fill: #e72233;
    }
    .overlay {
        position: fixed;
        z-index: 999;
        display: flex;
        width: 100%;
        height: 100%;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
    }
    .card {
        position: relative;
        margin: auto;
        background: #FFF;
        border-radius: 10px;
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .button-close {
        position: absolute;
        top: 5px;
        right: 5px;
        a {
            background: #FFF;
            font-size: 25px;
            padding: 5px 14px;
            border-radius: 50px;
            height: 40px;
            display: flex;
            width: 40px;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
    }
    .custom-select-newsletter {
        position: relative;

        .select-field {
            display: flex;
            justify-content: space-between;
            padding: 10px 20px;
            border: 1px solid #ccc;
            border-radius: 10px;
            align-items: center;
            transition: opacity 0.5s ease-out;
            position: relative;
            color: #424242;
        }
        .select-field.isActive {
            border-bottom: none;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }
        .wrap-selected {
            display: flex;
            flex-wrap: wrap;
            z-index: 1;
        }
        .selected-item {
            position: relative;
            border: 1px solid #ccc;
            padding: 2px 7px;
            border-radius: 5px;
            width: auto;
            background: #EFEFEF;
            color: #5A5A5A;
            font-size: 13px;
            margin-right: 5px;
            margin-bottom: 5px;
        }
        .dropdown-option {
            position: absolute;
            background: #FFF;
            border: 1px solid #ccc;
            width: 100%;
            padding: 10px 20px 10px;
            border-radius: 10px;
            z-index: 9;
            overflow: auto;
            max-height: 15em;
        }
        .dropdown-option.isActive {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            border-top: none;
            // position: relative;
        }
        .title-group {
            font-size: 15px;
        }
        .option-item {
            position: relative;
            display: flex;
            margin-top: 5px;
            flex-wrap: wrap;
            margin-bottom: 20px;
            .item {
                border: 1px solid #ccc;
                padding: 10px 20px;
                border-radius: 10px;
                margin: 5px 10px 5px 0;
                color: #5A5A5A;
                background: #FFF;
                cursor: pointer;
                &:hover {
                    background: #e72233;
                    color: #FFF;
                }
            }
            .item.selected {
                background: #e72233;
                color: #FFF;
            }
        }
        .footer-action {
            position: relative;
            display: flex;
            border-top: 1px solid #ccc;
            padding-top: 15px;
            justify-content: flex-end;
            margin-bottom: 10px;
        }

        .deleted-btn {
            color: #5A5A5A;
            margin-left: 6px;
            cursor: pointer;
        }
        .dropdown-arrow {
            padding: 0 10px;
            position: absolute;
            width: 100%;
            text-align: right;
            box-sizing: border-box;
            display: block;
            left: -10px;
            top: 9px;
        }
        .dropdown-arrow span i::before {
            cursor: pointer;
            transition: all 0.3s ease-in-out 0s;
        }

        .dropdown-arrow span.isActive i::before {
            transform: rotate(180deg);
        }

    }

    .with_pad {
        padding: 20px 0;
    }

    section {
        position: relative;
    }

    .line_title {
        width: 100%;
        margin-bottom: 20px;
        display: block;
        position: relative;
    }

    .line_title h3 .icon {
        display: inline-block;
        float: left;
        width: 50px;
        height: 50px;
        margin-top: 10px;
        background-repeat: no-repeat !important;
        margin-right: 10px;
    }

    .line_title h3 {
        color: #e21823;
        text-transform: uppercase;
        display: grid;
        grid-template-columns: minmax(20px, 0.1fr) auto minmax(20px, 1fr);
        align-items: center;
        grid-gap: 20px;
        width: 100%;
        margin: 0;
        font-size: 30px;
        line-height: 62px;
        color: #e92030;
    }

    .line_title h3:before,
    .line_title p:before,
    .line_title p:after,
    .line_title h3:after {
        content: "";
        border-top: 3px solid #e21823;
        width: auto !important;
        height: auto;
        position: relative !important;
        top: 0 !important;
        transform: none;
    }

    .line_title p {
        margin: 0;
    }

    .row_form {
        padding-bottom: 20px;
    }

    .row_form .main_title {
        text-align: left;
        margin-bottom: 15px;
    }

    .row_form .main_title h3 {
        font-size: 24px;
    }

    .group_form {
        display: block;
        width: 100%;
        margin-bottom: 15px;
    }

    .row_form {
        padding-bottom: 20px;
    }

    .row_form .main_title {
        text-align: left;
        margin-bottom: 15px;
    }

    .row_form .main_title h3 {
        font-size: 24px;
    }

    .group_form {
        display: block;
        width: 100%;
        margin-bottom: 15px;
    }

    .main_title {
        display: block;
        width: 100%;
        text-align: center;
        margin-bottom: 30px;
    }

    .main_title h3,
    .page_title h1 {
        font-size: 42px;
        line-height: 62px;
        color: #e92030;
        margin: 0;
        text-transform: uppercase;
    }

    .page_title {
        margin: 20px 0;
    }

    .page_title h1 {
        text-align: left;
    }

    .main_title p {
        font-size: 20px;
        line-height: 23px;
        text-align: center;
        color: #424242;
    }

    // FORM STYLE
    fieldset {
        margin: 0;
        border: none;
        padding: 0;
    }

    .form-group {
        position: relative;
        margin-bottom: 15px;
        display: flex;
        flex-direction: column;

        label {
            margin-bottom: 5px;
            font-size: 14px;
            text-transform: uppercase;
            color: #424242;
        }
    }

    .form-radio-custom {
        color:#727272;
        font-size: 14px;
        padding: 10px 20px;
        border: 1px solid #CCC;
        margin-bottom: 15px;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;

        label {
            margin-bottom: 0 !important;
            cursor: pointer;
            width: 100%;
            height: 100%;
        }
    }
    .form-radio-custom.selected {
        background: #E61B33;
        color: #FFF;
    }

    .form-control {
        padding: 13px 20px;
        border: 1px solid #CCC;
        margin-bottom: 10px;
        border-radius: 10px;
        display: flex;
        font-size: 14px;
    }

    input[type="radio"] {
        -webkit-appearance: none;
        appearance: none;
        /* For iOS < 15 to remove gradient background */
        background-color: #fff;
        /* Not removed via appearance */
        margin: 0;
        font: inherit;
        color: currentColor;
        width: 20px;
        height: 20px;
        border: none;
        border-radius: 50%;
        transform: translateY(-0.075em);
        display: none;
        place-content: center;
    }

    input[type="radio"]::before {
        content: "";
        width: 25px;
        height: 25px;
        border-radius: 50%;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em var(#FFF);
        background-color: #FFF;
    }

    input[type="radio"]:checked::before {
        transform: scale(1);
    }

    // input[type="radio"]:focus {
    //     outline: max(2px, 0.15em) solid #E61B33;
    //     outline-offset: max(2px, 0.15em);
    // }
    .subtitle-section {
        margin-bottom: 10px;
        color: #424242;
        text-transform: uppercase;
    }

    .red_bt {
        background: #e72233 none repeat scroll 0 0;
        border: none;
        color: #fff;
        cursor: pointer;
        display: block;
        margin: 0 10px;
        text-transform: capitalize;
        font-family: oswald, sans-serif;
        padding: 6px 20px;
        width: auto;
        font-size: 14px;
        height: 34px;
        line-height: 1.4em;
        border-radius: 10px;
    }

    .red_line_bt {
        background: #FFF;
        border: 1px solid #DBDBDB;
        color: #e72233;
        cursor: pointer;
        // display: block;
        margin: 0 10px;
        text-transform: capitalize;
        font-family: oswald, sans-serif;
        padding: 6px 20px;
        width: auto;
        font-size: 14px;
        height: 34px;
        line-height: 1.4em;
        border-radius: 10px;
    }
    .black_tx {
        color: #4F4F4F;
        text-transform: capitalize;
        font-size: 16px;

        &:hover {
            background: #e72233;
            color: #FFF;
        }
    }
    .row_button {
        display: block;
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        z-index: 10;
    }
    .error {
        border: 1px solid #e21823 !important;
    }


    .font-s-18 {
        font-size: 18px !important;
    }

    .flex-agreement {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .agreement input {
        margin-right: 10px;
    }

    .text-checkbox {
        color: #000;
    }
}


@media (max-width: 490px) {
    #newsletter-form-page {
        .card {
            margin-left: 10px !important;
            margin-right: 10px !important;
        }

        .line_title h3{
            font-size: 22px;
        }
        .row_form .main_title h3 {
            font-size: 20px;
        }
        .line_title h3 .icon {
            margin-top: 5px;
            margin-right: 5px;
        }
    }
}
</style>
